import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { tap } from 'rxjs/operators';
import { EffectivityCitizensCharter, RemarkResolvedStatusCitizensCharter, WorklistStatusCitizensCharter } from 'src/app/entities/worklist';
import { GovServiceService } from 'src/app/service/gov-service.service';
import { RequriementsService } from 'src/app/service/requriements.service';
import { ArtemisViewFeesComponent } from '../artemis-view-fees/artemis-view-fees.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import printJS from 'print-js';

@Component({
  selector: 'app-citizens-charter-service-view',
  templateUrl: './citizens-charter-service-view.component.html',
  styleUrls: ['./citizens-charter-service-view.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CitizensCharterServiceViewComponent implements OnInit {
  @ViewChild('printSection') printSection!: ElementRef;
  
  @Input() ccview:boolean =false
  @Input() service: any;
  @Input() counter: any;

  @Input() service_id: any;
  @Input() reviewMode: boolean = false;
  @Input() openRemarks: boolean = false;
  @Input() service_status: WorklistStatusCitizensCharter
  @Input() service_effectivity: EffectivityCitizensCharter

  client_Step: any = "ClientStep"
  agency_action: any = "AgencyAction"
  fees: any = 'Fees'
  worklist_status = WorklistStatusCitizensCharter
  effectivity = EffectivityCitizensCharter

  constructor(
    private auth: AngularFireAuth,
    private afs: AngularFirestore,
    private _service: GovServiceService,
    public requirementservice: RequriementsService,
    private matdialog: MatDialog,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef
  ) {
    
  }

  
printing:boolean=false
 print() {
  this.printing=true;
    printJS({
      printable: this.printSection.nativeElement,
      type: 'html',
      css: [
        // adjust path if you have a base href or prefix
        `${window.location.origin}/styles.scss`
      ],
      scanStyles: false ,  
      style:`* {
    visibility: hidden;
  }
    * {
  -webkit-print-color-adjust: exact !important;  /* Chrome, Safari */
  print-color-adjust: exact !important;          /* Firefox */
}

  /* show only our print section */
  #print-section,
  #print-section * {
    visibility: visible;
  }
  #print-section {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
  .table {
  table-layout: fixed;
  width: 100%;
}

.step {
  vertical-align: top;
}

.example-full-width {
  width: 100%;
}

.service-details {
  width: 100%;
  table-layout: fixed;
}

.service-details th,
.service-details td {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 0.5em 0.5em;
}

.service-details tbody {
  width: inherit;
}

.service-details tbody tr {
  width: inherit;
}

.service-details tbody tr th {
  background-color: rgb(21, 143, 199);
  font-weight: bold;
}

.service-details tbody tr .row-header {
  font-weight: bold;
}

/* Optional header-details (commented out)
.header-details th {
  width: 40%;
}

.header-details td {
  width: 60%;
}
*/

.content-center {
  display: flex;
  justify-content: center;
}

.subrequirement-table td {
  padding-left: 1rem;
}

.requirement-table,
.subsit-table,
.subrequirement-table {
  width: 100%;
}

.requirement-table th,
.requirement-table td,
.subsit-table th,
.subsit-table td,
.subrequirement-table th,
.subrequirement-table td {
  border: none;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  vertical-align: top;
}

/* 🔲 Visual Hierarchy for Levels */
.depth-1 td {
  padding-left: 0.75rem;
}

.depth-2 td {
  padding-left: 2rem;
}

.depth-3 td {
  padding-left: 3rem;
}

.depth-4 td {
  padding-left: 4.5rem;
  font-style: italic;
  opacity: 0.95;
}

/* 📘 Optional: Different font styles per depth */
.depth-1 td span,
.depth-1 td b {
  font-weight: bold;
}

.depth-2 td span,
.depth-2 td b {
  font-weight: 600;
}

.depth-3 td span,
.depth-3 td b {
  font-weight: normal;
  font-style: italic;
}

/* 🔹 Main Section Header */
.section-header {
  font-weight: bold;
  padding: 0.5rem 1rem;
  background-color: #a1d7fd;
  border-left: 4px solid #2196f3;
}

/* 🔹 Subsection Header */
.subsection-header {
  font-style: italic;
  font-weight: 600;
  padding: 0.5rem 1rem;
  background-color: #aed6ff;
  border-left: 4px solid #89c9fd;
}

/* 🔹 Subsection Highlight Wrapper */
.subsection-highlight {
  background-color: rgb(221, 221, 221);
  padding: 0.25rem 1rem;
  border-left: 3px solid #8f8f8f;
  font-style: italic;
  font-weight: 600;
}
table {
  /* collapse all table borders into one */
  border-collapse: collapse !important;
  /* remove any spacing between cells */
  border-spacing: 0 !important;
  /* kill any default top/bottom margin on the table itself */
  margin: 0 !important;
}
.middle-row-bot-border {
  border-bottom: 0.3px solid rgb(116, 116, 116);
}

.step_loc {
  overflow-wrap: break-word;
}

.step_notes {
  overflow-wrap: break-word;
  font-style: italic;
}

.my-tooltip {
  white-space: pre-line;
}

.mce-content-body table {
  border-collapse: collapse;
  width: 100%;
}

ul, ol {
  margin: 0.3rem !important;
  padding: 0 !important;
  font-size: small;

}

.mce-content-body th,
.mce-content-body td {
  border: 1px solid #000;
  padding: 5px;
}

    
  `
   
    });
    setTimeout(() => {
      this.printing=false
    }, 10);
  }

  sanitizeFormulafees(fee: any): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(fee)
  }

  getJSONValue(val: any) {
    let temp: any[] = []
    val.forEach((info: any) => {
      temp.push(info.name)
    })
    return JSON.stringify(temp)
  }

  ngOnInit(): void {

    this._service.maxHours = this.service.serviceDetails?.hour_per_day || 8

    this.loadRemarksData()

  }

  remarks_thread: any = []


  loadRemarksData() {
    if (!this.service_id) return;
    this.afs.collection("Service Remarks",
      filter => filter.where("service_id", "==", this.service_id)
        .where('status', '!=', RemarkResolvedStatusCitizensCharter.DELETED))
      .snapshotChanges().pipe(tap((data: any) => {
        this.remarks_thread = []

        data.forEach((info: any) => {

          let remark: any = info.payload.doc.data()
          remark._id = info.payload.doc.id;
          this.remarks_thread.push(remark)

        })
      })).subscribe()
  }


  async getCurrentUser() {

    const test = await this.auth.currentUser;
    const user_position = sessionStorage.getItem('account_subtype') || '';


    const remark_user = {
      email: test?.email,
      name: test?.displayName,
      user_id: test?.uid,
      position: user_position
    };

    return remark_user


  }


  get group_office() {

    const temp: any[] = [...this.service.serviceDetails.office_division, this.service.serviceDetails.process_owner]
    return temp.filter((f: any) => f?.groupOffice === true)
  }



  displaySteps(steps: any) {
    //console.log(steps)
  }

  filterFormulaFees(clientSteps: any[]) {
    let temp_array: any = []
    clientSteps.forEach((step: any) => {

      if (step.info?.list_of_formula_fees_arr && step.info.list_of_formula_fees_arr.length > 0) {

        step.info.list_of_formula_fees_arr.forEach((data: any) => {
          if (temp_array.filter((row: any) => row.fee_type == data.fee_type).length <= 0) {
            data.situation = step.info?.situation
            temp_array.push(data)
          }
        })

      }

    })
    return temp_array;
  }

  situational_clientStep(step: number, index: number) {
    //console.log("Situational Step",this.service.clientSteps[step].clientStep[index])
    return this.service.clientSteps[step].clientStep[index]
  }

  get situational_steps() {
    if (!this.service) return [];

    let return_arr: any[] = [];
    this.service.clientSteps.forEach((data: any) => {

      //console.log("Client Ste",data)
      //console.log(data);
      //situational client step object
      /**
       * data.situational : boolean
       * data.clientStep : array/ list of situational client step
       * data.situational_step_title title of situational step
       */
      if (data.situational) {
        //loop to situation client steps
        data.clientStep.forEach((situation: any) => {
          return_arr.push(situation);
        })
      }

    });

    return return_arr;
  }

  openFees(fees: any) {

    this.matdialog.open(ArtemisViewFeesComponent, {
      data: {
        fees: fees
      }
    })

  }

  filterOfficeDivision(value: any, array: any[] = []) {
    return array.filter((f: any) => f !== value).slice()
  }

  // Proxy method for actual computeTotalFees service
  computeTotalFees(client_step_arr: any, situationalStep?: any) {
    //console.log("Step array",this._service.computeTotalFees(client_step_arr, situationalStep))
    return this._service.computeTotalFees(client_step_arr, situationalStep);
  }

  // Proxy method for actual computeTotalProcessingTime service
  computeProcessingTime(client_step_arr: any, situationalStep?: any) {

    const { totalProcessingTimeStr, totalProcessingTimeStrCalendar } = this._service.computeTotalProcessingTimeV2(client_step_arr, this.service.serviceDetails?.hour_per_day ? this.service.serviceDetails.hour_per_day : 8, situationalStep)


   return `
  ${totalProcessingTimeStrCalendar ? 'Calendar Days: ' + totalProcessingTimeStrCalendar + '<br>' : ''}
  ${totalProcessingTimeStr ? 'Working Days: ' + totalProcessingTimeStr : ''}
`;

  }


  filterPossibleFees(clientSteps: any[]) {
    let temp_array: any = []
    clientSteps.forEach((step: any) => {

      if (step.info?.list_of_possible_fees_arr && step.info?.list_of_possible_fees_arr.length > 0) {

        step.info.list_of_possible_fees_arr.forEach((data: any) => {
          if (temp_array.filter((row: any) => row == data).length <= 0) {
            temp_array.push(data)
          }
        })

      }

    })

    return temp_array;
  }
}